import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import { AnimTap, EColors2, EFonts, EVariables } from 'libs/styles/styling';
import styled, { css } from 'styled-components/macro';

interface Props {
    iconName: IconName;
    text: string;
    onClick?: () => void;
    backgroundColor?: string;
    color?: string;
    disabled?: boolean;

    className?: string;
}

export const ReverseButton = (props: Props): JSX.Element => {
    const anim = props.disabled ? {} : AnimTap;

    return (
        <S_ReverseButton
            className={props.className}
            onClick={props.onClick}
            {...anim}
            $disabled={props.disabled}
        >
            <S_Text>{props.text}</S_Text>
            <S_Circle $backgroundColor={props.backgroundColor ?? EColors2.DARK}>
                <S_Icon $color={props.color ?? 'white'} icon={['far', props.iconName]} />
            </S_Circle>
        </S_ReverseButton>
    );
};

const S_ReverseButton = styled(motion.div)<{ $disabled: boolean }>`
    height: 44px;
    display: flex;
    background-color: #fafcfe;
    border-radius: ${EVariables.Radius1};
    align-items: center;
    width: fit-content;
    cursor: pointer;
    flex-shrink: 0;
    flex-grow: 0;
    ${(props) => {
        if (props.$disabled) {
            return css`
                cursor: not-allowed;
                background-color: #d3d6db;
            `;
        }
    }}
    @media only screen and (min-width: 1260px) {
        height: 44px;
        border: 1px solid #e3e3e3;
    }
`;

const S_Text = styled.div`
    color: ${EColors2.DARK};
    font-size: 14px;
    font-family: ${EFonts.InterMedium};
    padding: 0 15px 0 20px;
    white-space: nowrap;
    @media only screen and (min-width: 1260px) {
        padding: 0px 18px 0px 24px;
    }
`;

const S_Circle = styled.div<{ $backgroundColor: string }>`
    width: 40px;
    height: 40px;
    border-radius: 100%;
    background-color: ${(props) => props.$backgroundColor};
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 2px 0 0;
    @media only screen and (min-width: 1260px) {
        width: 40px;
        height: 40px;
    }
`;

const S_Icon = styled(FontAwesomeIcon)<{ $color: string }>`
    font-size: 18px;
    color: ${(props) => props.$color};
`;
